const menu = {
  'dashboard': 'Dashboard',
  'robot': 'License management',
  'manage-process': 'Process Management',
  'manage-task': 'Task Management',
  'manage-variable': 'Variable Management',
  'taskdata': 'Task Data',
  'log': 'Business Log',
  'application': 'Application Management',
  'reportforms': 'The report center',
  'reportforms-task': 'Task Report',
  'reportforms-robot': 'Robot Report',
  'reportforms-process': 'Ultimus Report',
  'reportforms-roi': 'Return On Investment Report',
  finance: {
    title: 'Financial Center',
    overview: 'Financial overview',
    details: 'Financial details'
  }
}

const copyright = {
  'links': 'China\'s first RPA vendor',
  'copyright': 'Shanghai i-Search Software Co., Ltd.,'
}

// 提示消息
const tip = {
  emptyText: 'No Data',
  success: 'success',
  error: 'error',
  editSuccess: 'Successful',
  editError: 'Failed',
  confirmSuccess: 'Successful',
  confirmError: 'Failed',
  addSuccess: 'Successful',
  addError: 'Failed',
  actionSuccess: 'Successful',
  actionError: 'Failed',
  deleteSuccess: 'Successful',
  deleteError: 'Failed',
  deleteTitle: 'Are you sure you want to delete?',
  cancelSuccess: 'Successful',
  cancelError: 'Failed',
  cancelled: 'Cancelled',
  cleared: 'Cleared'
}
// 分页信息
const pagination = {
  total: 'Total {total} items'
}

// 全局组件
const global = {
  // 搜索组件
  search: {
    placeHolder: 'search for...',
    btn: ['General search', 'Advanced Search']
  }
}

const custom = {
  menu,
  copyright,
  tip,
  pagination,
  global
}
export default custom
